import { Box, Stack, Typography } from '@mui/material';

export const IntegrationSourceCohortsUnderConstruction = () => {
  return (
    <Stack alignItems="center" justifyContent="center" pt={10}>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          maxWidth: 700,
          p: 3,
          textAlign: 'center',
        }}
      >
        <Typography fontSize={120}>🏗️</Typography>
        <Box>
          <Typography>
            We're are cooking up some exciting updates to enhance your cohorts
            integrations.
          </Typography>
          <Typography>Keep an eye out for what's coming!</Typography>
        </Box>
      </Stack>
    </Stack>
  );
};
